import $ from 'jquery';
window.jQuery = $;
require('bootstrap');
var _ = require('lodash');
import slick from 'slick-carousel';
import AOS from 'aos';
import matchHeight from 'jquery-match-height';

$(document).ready(function(){
  // Burger menu.
  function openMenu(open) {
    $('#burger').toggleClass('open', open);
    $('#navigation-mobile ul').toggleClass('open', open);
    
    if (open) {
      $('#top-bar').removeClass('d-block').css('display', 'none');
    } else {
      $('#top-bar').addClass('d-block').css('display', 'block');
    }

    if (!open) {
        $('.submenu').removeClass('open').hide();
    }
  }

  var open = false;
  $('#burger').on('click', function () {
      open = !open;
      openMenu(open);
  });

  $('.js-top-level-item').on('click', function (e) {
      e.preventDefault();
      var submenuId = $(this).data('submenu-id');
      $('#' + submenuId).addClass('open').show();
  });

  $('.js-back').on('click', function () {
      var parentMenuId = $(this).data('parent-menu');
      $('#' + parentMenuId).removeClass('open').hide();
  });

  // Active class.
  $('#header .nav > li > a[href]').each(function() { if (this.href == window.location.href) { $(this).addClass('active'); $(this).attr('arria-current', 'page'); } });

  // Dropdown-inner fix.
  function dropdown_fix() {
    if ($('.dropdown-inner').length) {
      var window_width = $(window).outerWidth();
  
      $('.dropdown-inner').css({
        width: window_width + 'px',
        left: 0
      });
  
      $('.dropdown-inner .container').css({
        margin: '0 auto',
        width: 'auto',
        padding: '0 0',
      });
    }
  }

  dropdown_fix();
  $(window).on('resize', function(){ dropdown_fix(); });

  // Scroll fix.
  function scrollFix() {
    var topstripHeight = $('#topstrip').outerHeight();
    var headerHeight = $('#header').outerHeight();
    headerHeight = headerHeight - 1;
    var dropdown = $('.dropdown-inner');
    var scroll = $(document).scrollTop();

    if (scroll == 0) {
      dropdown.css('top', (headerHeight + topstripHeight) + 'px');
    } else if (scroll < topstripHeight) {
      dropdown.css('top', ((topstripHeight - scroll) + headerHeight) + 'px');
    } else {
      dropdown.css('top', headerHeight + 'px');
    }
  }
  $(window).on('scroll', function(){ scrollFix(); });
  scrollFix();

  // Panel fix.
  function panel_fix() {
    if ($('.bg-wrapper.fill').length) {
      var target_height = $('.bg-wrapper.standard').outerHeight();
      $('.bg-wrapper.fill').children('.bg-portrait').css('padding', 0 + 'px').css('height', target_height + 'px');
    }
  }
  panel_fix();
  $(window).on('resize', function(){ panel_fix(); });

  // Front carousel.
  $('.carousel-front').slick({
    accessibility: true,
    arrows: false,
    draggable: true,
    fade: true,
    swipe: true,
    swipeToSlide: true,
    touchMove: true,
  });
  $('.carousel-front_images').slick({
    accessibility: true,
    arrows: false,
    asNavFor: '.carousel-front',
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    draggable: true,
    fade: true,
    swipe: true,
    swipeToSlide: true,
    touchMove: true,
  });

  // Sync dots on manual swipes
  $('.carousel-front').on('afterChange', function (event, slick, currentSlide) {
    $('.carousel-front_images').slick('slickGoTo', currentSlide);
  });

  // Hero dots.
  function hero_dots() {
    if ($('.carousel-front_images').length) {
      var window_width = $(window).outerWidth();
      var container_width = $('.container').outerWidth();
      container_width = container_width - 32;
      var left_offset = (window_width - container_width) / 2;
      if (window_width >= 992) {
        $('.carousel-front_images .slick-dots').css('left', left_offset + 'px');
      } else {
        $('.carousel-front_images .slick-dots').css('left', '50%');
      }
    }
  }
  hero_dots();
  $(window).on('resize', function(){ hero_dots(); });

  // Carousel base.
  $('.carousel-base').slick({
    infinite: false,
    mobileFirst: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fal fa-long-arrow-right fs-4"></i><span class="sr-only">Next slide</span></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fal fa-long-arrow-left fs-4"></i><span class="sr-only">Previous slide</span></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
    slidesToShow: 1,
  });

  // Carousel brands.
  $('.carousel-brands').slick({
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 4,
  });
  function brands_fix() {
    $('.carousel-brands button[data-bs-toggle="tab"]').on('click', function(){
      var item = $(this);
      setTimeout(function() {
        var ref = item.attr('data-bs-target');
        $('.carousel-brands button[data-bs-toggle="tab"]').removeClass('active');
        $('.carousel-brands button[data-bs-target="' + ref + '"]').addClass('active');
      }, 100);
    });
  }
  brands_fix();
  $(window).on('resize', function(){ brands_fix(); });

  // Accordion AOS fix.
  $('.faq-item button').on('click', function (){
    setTimeout(function(){ AOS.init(); }, 250);
  });
  $('.accordion button').on('click', function (){
    setTimeout(function(){ AOS.init(); }, 250);
  });

  // Tabs AOS fix.
  $('#nav-tab button').on('click', function (){
    AOS.init();
  });

  // Filters.
  $('.filters .parent').each(function(){
    var label = $(this);
    var ref = label.attr('data-ref');
    if (label.prev().is(':checked')) {
      label.addClass('active');
      $('.filters .child[data-ref=' + ref + '').css('display', 'block');
    }
  });
  $('.filters .parent').on('click', function(){
    var label = $(this);
    var ref = label.attr('data-ref');
    label.toggleClass('active');
  });
  $('.filters .parent + .filter-toggle').on('click', function(){
    var toggle = $(this);
    var ref = toggle.attr('data-ref');
    toggle.toggleClass('active');
    if (toggle.hasClass('active')) {
      $('.filters .child[data-ref=' + ref + '').css('display', 'block');
    } else {
      $('.filters .child[data-ref=' + ref + '').css('display', 'none');
    }
  });

  $('.filters label.child').each(function() {
    var label = $(this);
    var ref = label.attr('data-ref');
    if (label.prev().is(':checked')) {
      $('.filters .child[data-ref=' + ref + ']').css('display', 'block');
      $('.filters .parent[data-ref=' + ref + '] + span').addClass('active');
    }
  });

  // Notice.
  $('#notice-close').on('click', function(){
    $('#notice-wrapper').remove();
  });

  // AOS.
  AOS.init();
  setTimeout(function(){ AOS.init(); }, 500);

  const storeFinderSelect = $('.js-store-finder-select');

  if (storeFinderSelect.length > 0) {
    storeFinderSelect.select2({
      placeholder: 'Select a store',
    });
  }
});

// Google Maps.
(function($) {
  function new_map($el) {
    var $markers = $el.find('.marker');
    var args = {
      center: new google.maps.LatLng(0, 0),
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]}],
      zoom: 16,
    };
    var map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function(){
      add_marker($(this), map);
    });
    center_map(map);
    return map;
  }

  function add_marker($marker, map) {
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    var icon = {url: ''+$marker.attr('data-icon')+'', scaledSize: new google.maps.Size(24, 28)};
    var marker = new google.maps.Marker({
      icon: icon,
      map: map,
      position: latlng,
    });
    map.markers.push(marker);
    if($marker.html()){
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each( map.markers, function(i, marker){
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    if( map.markers.length == 1 ) {
      map.setCenter(bounds.getCenter());
      map.setZoom(13);
    } else {
      map.fitBounds(bounds);
    }
  }

  var map = null;
  $(document).ready(function(){
    $('.map').each(function(){
      map = new_map($(this));
    });
  });
})($);

document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('.js-top-level-item');
  const backButtons = document.querySelectorAll('.js-back');

  menuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const parentItem = link.parentElement;
      const submenuId = link.getAttribute('data-submenu-id');
      const submenu = document.querySelector(`#${submenuId}`);

      document.querySelectorAll('.menu-item.active').forEach(item => {
        item.classList.remove('active');
      });
      document.querySelectorAll('.submenu.visible').forEach(submenu => {
        submenu.classList.remove('visible');
      });

      parentItem.classList.add('active');

      if (submenu) {
        submenu.classList.add('visible');
      }
    });
  });

  backButtons.forEach(back => {
    back.addEventListener('click', (e) => {
      e.preventDefault();
  
      const parentSubmenuId = back.getAttribute('data-parent-menu');
      const parentSubmenu = document.querySelector(`#${parentSubmenuId}`);
      const parentMenuItem = back.closest('.menu-item');
      const parentTopLevelItem = parentMenuItem.closest('.js-top-level-item');
  
      if (parentSubmenu) {
        parentSubmenu.classList.remove('visible');
      }
  
      if (parentMenuItem) {
        parentMenuItem.classList.remove('active');
      }
  
      if (parentMenuItem) {
        parentMenuItem.dataset.submenuOpen = false;
      }
        
      if (parentTopLevelItem) {
        parentTopLevelItem.classList.remove('active');
      }
    });
  });  
});

document.addEventListener('DOMContentLoaded', () => {
const toggleButton = document.getElementById('toggle-filters');
  if (toggleButton) {
    toggleButton.addEventListener('click', () => {
      const mobileFilters = document.querySelector('.product-filter-form');
      const isActive = mobileFilters.classList.toggle('show');
      toggleButton.classList.toggle('active', isActive);
    });
  }
})
